import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import SoatRechargeModal from '../components/SoatRechargeModal';
import DetalleSoatModal from '../components/DetalleSoatModal';
import HistorialSoatModal from '../components/HistorialSoatModal';
import axios, { API_URL } from '../api/axiosConfig';
import './Dashboard.css';
import './SoatSubmodulo.css';
import * as XLSX from 'xlsx';

const SoatSubmodulo = () => {
  const { user } = useContext(AuthContext);
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('todos');
  const [showSaldoSoatsModal, setShowSaldoSoatsModal] = useState(false);
  const [showHistorialModal, setShowHistorialModal] = useState(false);

  // Modal Detalle Trámite
  const [selectedTramiteId, setSelectedTramiteId] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  // Modal / Pestaña de Carga de SOAT
  const [selectedItem, setSelectedItem] = useState(null);
  const [activeTab, setActiveTab] = useState('upload'); // 'upload' | 'view'
  const [soatFile, setSoatFile] = useState(null);
  const [numeroSoat, setNumeroSoat] = useState('');
  const [fechaCompra, setFechaCompra] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [uploading, setUploading] = useState(false);
  const [extractedValue, setExtractedValue] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadingPaquete, setDownloadingPaquete] = useState(false);

  const [soatBalance, setSoatBalance] = useState(0);

  // Estados para asignación de lotes
  const [showAssignedModal, setShowAssignedModal] = useState(false);
  const [assignedSoats, setAssignedSoats] = useState([]);
  const [assigning, setAssigning] = useState(false);

  useEffect(() => {
    fetchSolicitudes();
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
    try {
      const res = await axios.get('/api/tramites/soat-balance');
      setSoatBalance(res.data.balance || 0);
    } catch (err) {
      console.error('Error al consultar saldo SOAT:', err);
    }
  };

  const fetchSolicitudes = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/tramites/soat-submodule');
      setSolicitudes(res.data);
      setSelectedIds([]);
      setError('');
    } catch (err) {
      console.error('Error al cargar las solicitudes de SOAT:', err);
      setError('Error al consultar las solicitudes de Elektroas y Monterrey');
    } finally {
      setLoading(false);
    }
  };

  const fetchAssignedSoats = async () => {
    try {
      const res = await axios.get('/api/tramites/soat-asignados');
      setAssignedSoats(res.data);
    } catch (err) {
      console.error('Error al cargar SOATs asignados:', err);
    }
  };

  const handleAsignarLote = async () => {
    try {
      setAssigning(true);
      const res = await axios.post('/api/tramites/asignar-lote-soat');
      if (res.data.asignadosCount > 0) {
        alert(`Se te han asignado ${res.data.asignadosCount} nuevos SOATs pendientes.`);
      }
      await fetchAssignedSoats();
      setShowAssignedModal(true);
      fetchSolicitudes(); // Refresh main list
    } catch (err) {
      console.error('Error al asignar lote:', err);
      alert('Error al asignar lote de SOATs');
    } finally {
      setAssigning(false);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(filteredSolicitudes.map(item => item.id));
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectOne = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i => i !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const handleDownloadUnificado = async (idsToDownload, defaultPlateName = null) => {
    if (!idsToDownload || idsToDownload.length === 0) {
      alert('Por favor selecciona al menos un trámite para descargar.');
      return;
    }

    try {
      setDownloadingPaquete(true);
      const res = await axios.post(
        '/api/tramites/generar-paquete-soat',
        { tramite_ids: idsToDownload },
        { responseType: 'blob' }
      );

      let filename = idsToDownload.length === 1 
        ? `${defaultPlateName || 'Tramite_Unificado'}.pdf`
        : `Paquete_Documentos_SOAT_${Date.now()}.zip`;

      const disposition = res.headers['content-disposition'];
      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename="?([^";]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error al generar paquete de 3 documentos:', err);
      let errMsg = err.message;
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const parsed = JSON.parse(text);
          if (parsed.message) errMsg = parsed.message;
        } catch (e) {}
      }
      alert('❌ Error al generar el paquete de documentos unificados: ' + errMsg);
    } finally {
      setDownloadingPaquete(false);
    }
  };

  const handleOpenSoatTab = (item) => {
    setSelectedItem(item);
    const hasSoat = item.soat_estado === 'Vigente' || item.soat_estado === 'SOAT Cargado' || Boolean(item.soat_info?.numero);
    setActiveTab(hasSoat ? 'view' : 'upload');
    setSoatFile(null);
    setNumeroSoat(item.soat_info?.numero || '');
    setFechaCompra(item.soat_info?.fecha_compra || '');
    setFechaInicio(item.soat_info?.fecha_inicio || '');
    setFechaFin(item.soat_info?.fecha_fin || '');
    setExtractedValue(item.valor_soat || null);
    setSuccessMsg('');
    setError('');
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setSoatFile(null);
    setExtractedValue(null);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSoatFile(e.target.files[0]);
    }
  };

  const handleUploadAndExtractSOAT = async (e) => {
    e.preventDefault();
    if (!selectedItem) return;
    if (!soatFile && !numeroSoat) {
      setError('Por favor selecciona el archivo PDF del SOAT o ingresa el número.');
      return;
    }

    setUploading(true);
    setError('');
    setSuccessMsg('');

    try {
      const formData = new FormData();
      if (soatFile) {
        formData.append('soat_pdf', soatFile);
      }
      formData.append('numero_soat', numeroSoat);
      formData.append('fecha_compra', fechaCompra);
      formData.append('fecha_inicio', fechaInicio);
      formData.append('fecha_fin', fechaFin);

      const res = await axios.post(`/api/tramites/${selectedItem.id}/cargar-soat`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const val = res.data.valor_soat || res.data.soat_info?.valor_soat;
      setExtractedValue(val);
      setSuccessMsg(`✅ SOAT cargado y procesado exitosamente.${val ? ` Valor detectado: $${parseFloat(val).toLocaleString('es-CO')}` : ''}`);

      // Actualizar listado local y saldo
      fetchSolicitudes();
      fetchBalance();

      setTimeout(() => {
        if (activeTab === 'upload' && res.data.soat_info) {
          setActiveTab('view');
        }
      }, 1200);

    } catch (err) {
      console.error('Error al cargar el SOAT:', err);
      setError(err.response?.data?.message || 'Error al procesar el archivo SOAT');
    } finally {
      setUploading(false);
    }
  };

  const openAssignedSoatTab = (item) => {
    setShowAssignedModal(false);
    handleOpenSoatTab(item);
  };

  const [previewUnificadoUrl, setPreviewUnificadoUrl] = useState(null);
  const [loadingUnificado, setLoadingUnificado] = useState(false);

  const handlePreviewUnificado = async (id) => {
    try {
      setLoadingUnificado(true);
      const res = await axios.post(
        '/api/tramites/generar-paquete-soat',
        { tramite_ids: [id] },
        { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      setPreviewUnificadoUrl(url);
    } catch (err) {
      console.error('Error al generar vista previa unificada:', err);
      alert('❌ Error al generar el PDF unificado para visualización.');
    } finally {
      setLoadingUnificado(false);
    }
  };

  const closePreviewUnificado = () => {
    if (previewUnificadoUrl) {
      window.URL.revokeObjectURL(previewUnificadoUrl);
      setPreviewUnificadoUrl(null);
    }
  };

  const [requestDateFilter, setRequestDateFilter] = useState('');

  // Filtrado de solicitudes
  const filteredSolicitudes = solicitudes.filter(item => {
    const matchesSearch = 
      item.placa.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.id.toString().includes(searchTerm) ||
      (item.concesionario && item.concesionario.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.tipo_tramite && item.tipo_tramite.toLowerCase().includes(searchTerm.toLowerCase()));

    let matchesStatus = true;
    if (statusFilter === 'vigente') matchesStatus = item.soat_estado === 'Vigente';
    if (statusFilter === 'cargado') matchesStatus = item.soat_estado === 'SOAT Cargado';
    if (statusFilter === 'pendiente') matchesStatus = item.soat_estado === 'Pendiente SOAT' || !item.soat_estado;
    if (statusFilter === 'falta_archivo') matchesStatus = !item.soat_pdf_filename && !item.soat_info?.validado_pdf;

    let matchesDate = true;
    if (requestDateFilter) {
      const createdDateStr = item.created_at ? new Date(item.created_at).toISOString().split('T')[0] : '';
      const preDateStr = item.fecha_preasignacion ? new Date(item.fecha_preasignacion).toISOString().split('T')[0] : '';
      matchesDate = createdDateStr === requestDateFilter || preDateStr === requestDateFilter;
    }

    return matchesSearch && matchesStatus && matchesDate;
  });

  // Estadísticas
  const totalSolicitudes = solicitudes.length;
  const totalVigentes = solicitudes.filter(s => s.soat_estado === 'Vigente').length;
  const totalPendientes = solicitudes.filter(s => s.soat_estado === 'Pendiente SOAT' || !s.soat_estado).length;
  const totalFaltaArchivo = solicitudes.filter(s => !s.soat_pdf_filename && !s.soat_info?.validado_pdf).length;
  const sumaValoresSoat = solicitudes.reduce((acc, curr) => acc + (parseFloat(curr.valor_soat) || 0), 0);

  const totalPagados = solicitudes.filter(s => 
    s.soat_estado === 'SOAT Cargado' || 
    s.soat_estado?.includes('Futuro') ||
    s.datos_adicionales?.soat_cargado === true || 
    s.datos_adicionales?.soat_cargado === 'true' ||
    Boolean(s.soat_pdf_filename) ||
    Boolean(s.soat_info?.numero)
  ).length;

  // Costo de cargar un SOAT: su valor real (si ya se pagó) o el estimado por cilindraje/tipo
  // (calculado en el backend según el tarifario), más la comisión del proveedor vigente.
  const PROVEEDOR_FEE = 15000;
  const getCostoSoat = (item) => {
    const valor = parseFloat(item.valor_soat) || parseFloat(item.valor_soat_estimado) || 0;
    return valor > 0 ? valor + PROVEEDOR_FEE : 0;
  };

  // Para el botón de recarga: cuánto saldo se necesita para pagar los trámites seleccionados
  // que todavía no tienen SOAT cargado (los ya pagados no cuentan).
  const seleccionadosSinSoat = solicitudes.filter(s => selectedIds.includes(s.id) && !s.soat_info?.numero && !s.soat_pdf_filename);
  const totalARecargar = seleccionadosSinSoat.reduce((acc, s) => acc + getCostoSoat(s), 0);
  const seleccionadosSinValor = seleccionadosSinSoat.filter(s => getCostoSoat(s) === 0).length;

  const formatCurrency = (val) => {
    if (!val) return 'Sin Valor Lectura';
    const num = parseFloat(val);
    if (isNaN(num)) return val;
    return `$ ${num.toLocaleString('es-CO')}`;
  };

  const getVehicleIcon = (type) => {
    const t = (type || '').toLowerCase();
    if (t.includes('moto')) return '🏍️';
    if (t.includes('camion') || t.includes('carga')) return '🚚';
    return '🚗';
  };

  const handleExportExcel = () => {
    if (filteredSolicitudes.length === 0) {
      alert("No hay datos para exportar");
      return;
    }

    const dataToExport = filteredSolicitudes.map(item => ({
      "ID Solicitud": item.id,
      "Concesionario": item.concesionario || '',
      "Tipo Trámite": item.tipo_tramite || '',
      "Placa": item.placa || '',
      "Tipo Vehículo": item.vehicle_type || '',
      "Estado SOAT": item.soat_estado || 'Pendiente',
      "Valor SOAT": item.valor_soat ? parseFloat(item.valor_soat) : 0,
      "Número Póliza": item.soat_info?.numero || '',
      "Fecha Compra SOAT": item.soat_info?.fecha_compra || '',
      "Fecha Preasignación": item.fecha_preasignacion ? new Date(item.fecha_preasignacion).toLocaleString('es-CO') : '',
      "Fecha Creación": item.created_at ? new Date(item.created_at).toLocaleString('es-CO') : ''
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SOATs");
    XLSX.writeFile(wb, `Reporte_SOATs_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return (
    <div className="app-layout">
      <Sidebar userRole={user?.role} />
      <div className="main-content">
        <Navbar title="🛡️ Submódulo SOAT" />

        <div className="page-content soat-page-container">
          {error && <div className="error-banner">{error}</div>}

          {/* Tarjetas Estadísticas */}
          <div className="soat-header-bar">
            <h3 style={{ margin: 0, fontSize: '18px', color: '#1e293b' }}>📊 Estado de SOATs y Gestión</h3>
            {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (
              <div className="soat-header-actions">
                <button
                  className="btn-primary"
                  onClick={() => setShowHistorialModal(true)}
                  style={{
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    padding: '10px 18px',
                    borderRadius: '10px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)'
                  }}
                >
                  📜 Ver Historial
                </button>
                <button
                  className="btn-primary"
                  onClick={() => setShowSaldoSoatsModal(true)}
                  style={{
                    background: '#16a34a',
                    color: 'white',
                    border: 'none',
                    padding: '10px 18px',
                    borderRadius: '10px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 4px rgba(22, 163, 74, 0.2)'
                  }}
                >
                  💰 Recargar Saldo SOAT
                </button>
              </div>
            )}
            <div className="soat-header-actions">
              <button
                className="btn-primary"
                onClick={handleAsignarLote}
                disabled={assigning}
                style={{
                  background: '#8b5cf6',
                  color: 'white',
                  border: 'none',
                  padding: '10px 18px',
                  borderRadius: '10px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 4px rgba(139, 92, 246, 0.3)'
                }}
              >
                {assigning ? '⏳ Asignando...' : '🎯 Mis SOATs Asignados'}
              </button>
            </div>
          </div>

          <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
            {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (
              <div className="stat-card success" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
                <div className="stat-icon" style={{ background: '#dcfce7', color: '#16a34a' }}>💰</div>
                <div className="stat-details">
                  <span className="stat-label" style={{ color: '#15803d', fontWeight: '700' }}>Saldo Disponible SOAT</span>
                  <span className="stat-value" style={{ color: '#166534', fontWeight: '800' }}>$ {Number(soatBalance).toLocaleString('es-CO')}</span>
                </div>
              </div>
            )}
            <div className="stat-card info">
              <div className="stat-icon">📄</div>
              <div className="stat-details">
                <span className="stat-label">Solicitudes SOAT</span>
                <span className="stat-value">{totalSolicitudes}</span>
              </div>
            </div>
            <div className="stat-card success">
              <div className="stat-icon">🛡️</div>
              <div className="stat-details">
                <span className="stat-label">SOATs Vigentes</span>
                <span className="stat-value">{totalVigentes}</span>
              </div>
            </div>
            <div className="stat-card warning">
              <div className="stat-icon">⏳</div>
              <div className="stat-details">
                <span className="stat-label">SOATs Pendientes</span>
                <span className="stat-value">{totalPendientes}</span>
              </div>
            </div>
            <div className="stat-card" style={{ background: '#f5f3ff', borderColor: '#ddd6fe' }}>
              <div className="stat-icon" style={{ background: '#ede9fe', color: '#7c3aed' }}>💳</div>
              <div className="stat-details">
                <span className="stat-label" style={{ color: '#6d28d9', fontWeight: '700' }}>SOATs Pagados</span>
                <span className="stat-value" style={{ color: '#5b21b6' }}>{totalPagados}</span>
              </div>
            </div>
            <div className="stat-card primary">
              <div className="stat-icon">🏷️</div>
              <div className="stat-details">
                <span className="stat-label">Valor Total SOATs</span>
                <span className="stat-value">$ {sumaValoresSoat.toLocaleString('es-CO')}</span>
              </div>
            </div>
          </div>

          {/* Filtros de la Tabla */}
          <div className="table-section">
            <div className="soat-filters-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
              <div className="soat-filters-group">
                <div className="search-box">
                  <span className="search-icon">🔍</span>
                  <input
                    type="text"
                    placeholder="Buscar por placa, ID o concesionario..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </div>
                <div className="status-filter-pills">
                  <button
                    className={`filter-pill ${statusFilter === 'todos' ? 'active' : ''}`}
                    onClick={() => setStatusFilter('todos')}
                  >
                    Todos ({totalSolicitudes})
                  </button>
                  <button
                    className={`filter-pill ${statusFilter === 'vigente' ? 'active' : ''}`}
                    onClick={() => setStatusFilter('vigente')}
                  >
                    Vigentes ({totalVigentes})
                  </button>
                  <button
                    className={`filter-pill ${statusFilter === 'cargado' ? 'active' : ''}`}
                    onClick={() => setStatusFilter('cargado')}
                  >
                    SOATs Pagados ({totalPagados})
                  </button>
                  <button
                    className={`filter-pill ${statusFilter === 'pendiente' ? 'active' : ''}`}
                    onClick={() => setStatusFilter('pendiente')}
                  >
                    Pendientes ({totalPendientes})
                  </button>
                  <button
                    className={`filter-pill ${statusFilter === 'falta_archivo' ? 'active' : ''}`}
                    onClick={() => setStatusFilter('falta_archivo')}
                    style={{
                      background: statusFilter === 'falta_archivo' ? '#ef4444' : '',
                      color: statusFilter === 'falta_archivo' ? '#ffffff' : '#ef4444',
                      borderColor: '#ef4444'
                    }}
                  >
                    ⚠️ Falta Archivo PDF ({totalFaltaArchivo})
                  </button>
                </div>

                {/* Filtro por fecha de solicitud */}
                <div className="soat-date-filter" style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#ffffff', padding: '6px 12px', borderRadius: '10px', border: '1px solid #cbd5e1', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                  <label htmlFor="soat-fecha-solicitud" style={{ fontSize: '13px', fontWeight: '700', color: '#334155', whiteSpace: 'nowrap' }}>📅 Fecha Solicitud:</label>
                  <input
                    id="soat-fecha-solicitud"
                    type="date"
                    value={requestDateFilter}
                    onChange={(e) => setRequestDateFilter(e.target.value)}
                    style={{ padding: '4px 8px', fontSize: '13px', border: '1px solid #cbd5e1', borderRadius: '6px', cursor: 'pointer', outline: 'none', background: '#f8fafc' }}
                  />
                  {requestDateFilter && (
                    <button
                      onClick={() => setRequestDateFilter('')}
                      style={{
                        background: '#ef4444',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      title="Limpiar filtro de fecha"
                    >
                      &times;
                    </button>
                  )}
                </div>
              </div>

              <div className="soat-export-actions">
                <button
                  className="btn-secondary"
                  onClick={handleExportExcel}
                  style={{
                    background: '#22c55e',
                    color: '#ffffff',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 4px rgba(34, 197, 94, 0.2)'
                  }}
                >
                  📊 Exportar Excel
                </button>

              {selectedIds.length > 0 && (
                <button
                  className="btn-primary"
                  onClick={() => handleDownloadUnificado(selectedIds)}
                  disabled={downloadingPaquete}
                  style={{
                    background: '#10b981',
                    color: '#ffffff',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)'
                  }}
                >
                  {downloadingPaquete ? '⌛ Generando...' : `📦 Descargar 3 Docs Unificados (${selectedIds.length})`}
                </button>
              )}
              </div>
            </div>

            {/* Total a recargar para pagar los SOAT seleccionados (excluye los ya cargados) */}
            {selectedIds.length > 0 && (
              <div style={{
                marginTop: '12px', padding: '14px 18px', background: '#fffbeb', border: '1px solid #fde68a',
                borderRadius: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px'
              }}>
                <div style={{ fontSize: '13px', color: '#92400e' }}>
                  <strong>{selectedIds.length}</strong> seleccionado(s)
                  {seleccionadosSinSoat.length !== selectedIds.length && (
                    <> · <strong>{seleccionadosSinSoat.length}</strong> sin SOAT cargado aún (solo esos cuentan para la recarga)</>
                  )}
                  {seleccionadosSinValor > 0 && (
                    <> · <span style={{ color: '#dc2626' }}>{seleccionadosSinValor} sin cilindraje conocido (no incluido en el total)</span></>
                  )}
                </div>
                <div style={{ fontSize: '18px', fontWeight: '800', color: '#92400e' }}>
                  💵 Total a recargar: $ {totalARecargar.toLocaleString('es-CO')}
                </div>
              </div>
            )}

            {/* Tabla Principal */}
            {loading ? (
              <div className="loading-spinner-container">
                <div className="spinner"></div>
                <p>Cargando solicitudes de SOAT...</p>
              </div>
            ) : (
              <div className="table-responsive soat-main-table">
                <table className="custom-table soat-table">
                  <thead>
                    <tr>
                      <th style={{ width: '40px', textAlign: 'center' }}>
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={filteredSolicitudes.length > 0 && selectedIds.length === filteredSolicitudes.length}
                          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                        />
                      </th>
                      <th>Solicitud / Origen</th>
                      <th>Placa</th>
                      <th>Tipo Vehículo</th>
                      <th>Estado del SOAT</th>
                      <th>Valor del SOAT</th>
                      <th>Costo a Recargar</th>
                      <th className="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSolicitudes.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="no-data">
                          No se encontraron solicitudes registradas
                        </td>
                      </tr>
                    ) : (
                      filteredSolicitudes.map((item) => (
                        <tr key={item.id} className="soat-row-item">
                          <td className="soat-cell-check" data-label="Seleccionar" style={{ textAlign: 'center' }}>
                            <input
                              type="checkbox"
                              checked={selectedIds.includes(item.id)}
                              onChange={() => handleSelectOne(item.id)}
                              style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                            />
                          </td>
                          <td data-label="Solicitud">
                            <div className="solicitud-info">
                              <span className="solicitud-id">#{item.id}</span>
                              {(!user?.role?.includes('asesor_soat') && user?.profile_name !== 'asesor_soat' && user?.username !== 'ruberth.rojas' && !item.hide_concesionario && item.concesionario) && (
                                <span className="solicitud-company">{item.concesionario}</span>
                              )}
                              <span className="solicitud-tramite">{item.tipo_tramite}</span>
                              <span className="solicitud-fecha-preasignacion" style={{ fontSize: '11px', color: '#475569', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600' }}>
                                🕒 {new Date(item.fecha_preasignacion || item.created_at).toLocaleString('es-CO')}
                              </span>
                            </div>
                          </td>
                          <td data-label="Placa">
                            <span className="plate-badge">
                              {item.placa}
                            </span>
                          </td>
                          <td data-label="Tipo Vehículo">
                            <span className="vehicle-type-badge">
                              {getVehicleIcon(item.vehicle_type)} {item.vehicle_type.toUpperCase()}
                            </span>
                          </td>
                          <td data-label="Estado SOAT">
                            <span className={`soat-status-badge ${
                              item.soat_estado === 'Vigente' ? 'status-vigente' :
                              item.soat_estado?.includes('Futuro') ? 'status-cargado' :
                              item.soat_estado === 'SOAT Cargado' ? 'status-cargado' : 'status-pendiente'
                            }`}>
                              {item.soat_estado === 'Vigente' && '🟢 '}
                              {item.soat_estado?.includes('Futuro') && '📅 '}
                              {item.soat_estado === 'SOAT Cargado' && '🔵 '}
                              {item.soat_estado === 'Pendiente SOAT' && '🟡 '}
                              {item.soat_estado}
                            </span>
                            {(!item.soat_pdf_filename && !item.soat_info?.validado_pdf) && (
                              <div style={{ marginTop: '4px' }}>
                                <span style={{
                                  padding: '2px 6px',
                                  borderRadius: '4px',
                                  fontSize: '10px',
                                  fontWeight: '800',
                                  background: '#fef2f2',
                                  color: '#dc2626',
                                  border: '1px solid rgba(220, 38, 38, 0.2)',
                                  whiteSpace: 'nowrap'
                                }} title="Este trámite aún no tiene el archivo PDF del SOAT adjunto">
                                  ⚠️ SIN PDF ADJUNTO
                                </span>
                              </div>
                            )}
                          </td>
                          <td data-label="Valor SOAT">
                            <div className="valor-soat-container">
                              <span className={`valor-soat-text ${item.valor_soat ? 'has-value' : 'no-value'}`}>
                                {formatCurrency(item.valor_soat)}
                              </span>
                              {item.soat_info?.numero && (
                                <span className="soat-numero-sub text-muted">
                                  Póliza: {item.soat_info.numero}
                                </span>
                              )}
                            </div>
                          </td>
                          <td data-label="Costo a Recargar">
                            {item.valor_soat ? (
                              // Ya tiene el valor real del PDF; el costo a recargar ya quedó registrado al cargarlo.
                              <span style={{ fontSize: '12px', color: '#64748b' }}>—</span>
                            ) : item.valor_soat_estimado ? (
                              <span style={{ fontWeight: '700', color: '#b45309' }} title="Estimado según cilindraje/tipo de vehículo; puede variar un poco respecto al valor real del PDF.">
                                ~ {formatCurrency(item.valor_soat_estimado + PROVEEDOR_FEE)}
                              </span>
                            ) : (
                              <span style={{ fontSize: '11px', color: '#94a3b8' }} title="Falta el cilindraje/tipo de vehículo para poder estimarlo">
                                Sin cilindraje
                              </span>
                            )}
                          </td>
                          <td className="text-center soat-cell-actions" data-label="Acciones">
                            <div className="soat-row-actions">
                              <button
                                onClick={() => handleDownloadUnificado([item.id], item.placa)}
                                className="btn-secondary"
                                style={{
                                  padding: '6px 12px',
                                  fontSize: '12px',
                                  borderRadius: '6px',
                                  fontWeight: '700',
                                  background: '#10b981',
                                  color: '#ffffff',
                                  border: 'none',
                                  cursor: 'pointer',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}
                                title={`Descargar los 3 documentos unificados en un solo PDF nombrado ${item.placa}.pdf`}
                                disabled={downloadingPaquete}
                              >
                                📥 PDF Unificado ({item.placa})
                              </button>
                              <button
                                onClick={() => {
                                  setSelectedTramiteId(item.id);
                                  setIsDetailModalOpen(true);
                                }}
                                className="btn-secondary"
                                style={{ padding: '6px 12px', fontSize: '12px', borderRadius: '6px', fontWeight: '700' }}
                                title="Ver propietario, información del vehículo y documentos"
                              >
                                👁️ Ver Detalle
                              </button>
                              <button
                                onClick={() => handleOpenSoatTab(item)}
                                className="btn-tab-soat"
                              >
                                📂 Pestaña SOAT
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* MODAL DE SOATs ASIGNADOS AL USUARIO */}
      {showAssignedModal && (
        <div className="modal-overlay" onClick={() => setShowAssignedModal(false)}>
          <div className="modal-content" style={{ maxWidth: '800px', width: '90%' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 style={{ margin: 0, fontSize: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                🎯 Mis SOATs Asignados por Hacer
              </h3>
              <button className="close-btn" onClick={() => setShowAssignedModal(false)}>&times;</button>
            </div>
            <div className="modal-body" style={{ padding: '20px' }}>
              <p style={{ color: '#475569', marginBottom: '15px' }}>
                Estos trámites te han sido asignados exclusivamente a ti para que cargues el SOAT. Tienes <strong>{assignedSoats.length}</strong> SOAT(s) en tu lote actual.
              </p>
              
              {assignedSoats.length === 0 ? (
                <div style={{ background: '#f8fafc', padding: '30px', textAlign: 'center', borderRadius: '8px', border: '1px dashed #cbd5e1' }}>
                  <span style={{ fontSize: '24px' }}>✅</span>
                  <p style={{ marginTop: '10px', fontWeight: '600', color: '#334155' }}>No tienes SOATs pendientes asignados en este momento.</p>
                  <p style={{ fontSize: '13px', color: '#64748b' }}>Haz clic de nuevo en el botón "Mis SOATs Asignados" para pedir un nuevo lote al sistema si hay disponibles.</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="custom-table soat-table">
                    <thead>
                      <tr>
                        <th>Trámite ID</th>
                        <th>Placa</th>
                        <th>Tipo</th>
                        <th>Concesionario</th>
                        <th className="text-center">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedSoats.map(item => (
                        <tr key={item.id}>
                          <td>#{item.id}</td>
                          <td><span className="plate-badge">{item.placa}</span></td>
                          <td>{getVehicleIcon(item.vehicle_type)} {item.vehicle_type}</td>
                          <td>{item.concesionario}</td>
                          <td className="text-center">
                            <button
                              onClick={() => openAssignedSoatTab(item)}
                              className="btn-tab-soat"
                              style={{ padding: '6px 12px', fontSize: '12px' }}
                            >
                              📂 Procesar SOAT
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* MODAL / PESTAÑA DE CARGA Y LECTURA DE SOAT */}
      {selectedItem && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div 
            className="modal-content soat-modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={previewUnificadoUrl ? { maxWidth: '95vw', width: '95vw', height: '95vh', display: 'flex', flexDirection: 'column' } : {}}
          >
            <div className="modal-header">
              <div className="header-title-container">
                <h3>📂 Pestaña SOAT - Solicitud #{selectedItem.id}</h3>
                <div className="sub-header-details">
                  <span className="plate-pill">{selectedItem.placa}</span>
                  {(!user?.role?.includes('asesor_soat') && user?.profile_name !== 'asesor_soat' && user?.username !== 'ruberth.rojas' && !selectedItem.hide_concesionario && selectedItem.concesionario) && (
                    <span className="company-pill">{selectedItem.concesionario}</span>
                  )}
                  <span className="vehicle-pill">{getVehicleIcon(selectedItem.vehicle_type)} {selectedItem.vehicle_type}</span>
                </div>
              </div>
              <button className="close-btn" onClick={() => { handleCloseModal(); closePreviewUnificado(); }}>&times;</button>
            </div>

            {/* Pestañas de navegación interna en el modal */}
            <div className="modal-tabs-header">
              <button
                className={`modal-tab-btn ${activeTab === 'upload' ? 'active' : ''}`}
                onClick={() => setActiveTab('upload')}
              >
                📤 Cargar y Leer Documento SOAT
              </button>
              <button
                className={`modal-tab-btn ${activeTab === 'view' ? 'active' : ''}`}
                onClick={() => setActiveTab('view')}
              >
                👁️ Ver Lectura & Previsualizar PDF
              </button>
              <button
                className="modal-tab-btn"
                style={{ marginLeft: 'auto', background: '#3b82f6', color: '#fff' }}
                onClick={() => handlePreviewUnificado(selectedItem.id)}
                disabled={loadingUnificado}
              >
                {loadingUnificado ? '⌛ Generando...' : '📄 Ver PDF Unificado'}
              </button>
            </div>

            <div className={`modal-body soat-modal-body ${previewUnificadoUrl ? 'with-preview' : ''}`} style={{ display: 'flex', gap: '20px', flex: previewUnificadoUrl ? 1 : 'none', minHeight: previewUnificadoUrl ? 0 : 'auto', overflow: previewUnificadoUrl ? 'hidden' : 'auto' }}>
              <div className="soat-modal-form-col" style={{ flex: previewUnificadoUrl ? '0 0 450px' : 1, overflowY: 'auto', paddingRight: previewUnificadoUrl ? '15px' : 0 }}>
                {error && <div className="modal-error-banner">{error}</div>}
                {successMsg && <div className="modal-success-banner">{successMsg}</div>}

              {activeTab === 'upload' ? (
                <form onSubmit={handleUploadAndExtractSOAT} className="soat-upload-form">
                  <div className="drag-upload-zone">
                    <input
                      type="file"
                      accept=".pdf"
                      id="soatPdfInput"
                      onChange={handleFileChange}
                      className="hidden-file-input"
                    />
                    <label htmlFor="soatPdfInput" className="drag-upload-label">
                      <div className="upload-icon">📄</div>
                      <div className="upload-text">
                        {soatFile ? (
                          <strong className="selected-filename">📌 {soatFile.name}</strong>
                        ) : (
                          <>
                            <strong>Haz clic o arrastra aquí el documento PDF del SOAT</strong>
                            <span>Se extraerá y leerá automáticamente el valor y la póliza</span>
                          </>
                        )}
                      </div>
                    </label>
                  </div>

                  <div className="form-grid-2">
                    <div className="form-group">
                      <label>Número de Póliza / SOAT</label>
                      <input
                        type="text"
                        placeholder="Ej. 14008291029"
                        value={numeroSoat}
                        onChange={(e) => setNumeroSoat(e.target.value)}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <label>Vigencia Desde (Inicio)</label>
                      <input
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <label>Vigencia Hasta (Vencimiento)</label>
                      <input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                        className="form-input"
                      />
                    </div>
                  </div>

                  {extractedValue && (
                    <div className="extracted-value-card">
                      <span className="card-label">Valor del SOAT Detectado:</span>
                      <span className="card-value">$ {parseFloat(extractedValue).toLocaleString('es-CO')}</span>
                    </div>
                  )}

                  <div className="modal-actions-bar">
                    <button
                      type="button"
                      className="btn-cancel"
                      onClick={handleCloseModal}
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      disabled={uploading}
                      className="btn-submit-soat"
                    >
                      {uploading ? (
                        <>
                          <span className="button-spinner"></span> Leyendo y Procesando SOAT...
                        </>
                      ) : (
                        '💾 Cargar SOAT y Procesar Valor'
                      )}
                    </button>
                  </div>
                </form>
              ) : (
                <div className="soat-view-tab-content">
                  <div className="read-details-card">
                    <h4>📊 Resumen de Lectura del SOAT</h4>
                    <div className="details-grid">
                      <div className="detail-item">
                        <span className="d-label">Estado SOAT:</span>
                        <span className="d-val bold">{selectedItem.soat_estado}</span>
                      </div>
                      <div className="detail-item">
                        <span className="d-label">Valor SOAT Extraído:</span>
                        <span className="d-val highlight">
                          {formatCurrency(extractedValue || selectedItem.valor_soat)}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="d-label">Número de Póliza:</span>
                        <span className="d-val">{selectedItem.soat_info?.numero || numeroSoat || 'No especificado'}</span>
                      </div>
                      <div className="detail-item">
                        <span className="d-label">Fecha de Verificación:</span>
                        <span className="d-val">
                          {selectedItem.soat_info?.verificado_at 
                            ? new Date(selectedItem.soat_info.verificado_at).toLocaleString('es-CO')
                            : 'Reciente'}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="pdf-preview-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                      <h5 style={{ margin: 0 }}>📄 Documento / Certificado de SOAT</h5>
                      <a
                        href={`${API_URL}/api/tramites/${selectedItem.id}/soat-pdf?token=${localStorage.getItem('token')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-secondary"
                        style={{
                          padding: '6px 12px',
                          fontSize: '12px',
                          textDecoration: 'none',
                          background: '#3b82f6',
                          color: '#ffffff',
                          borderRadius: '6px',
                          fontWeight: '600'
                        }}
                      >
                        🔗 Abrir / Descargar PDF SOAT
                      </a>
                    </div>

                    <div className="iframe-container">
                      <iframe
                        title={`PDF SOAT ${selectedItem.placa}`}
                        src={`${API_URL}/api/tramites/${selectedItem.id}/soat-pdf?token=${localStorage.getItem('token')}`}
                        width="100%"
                        height="520px"
                        style={{ border: '1px solid #cbd5e1', borderRadius: '8px' }}
                      ></iframe>
                    </div>
                  </div>
                </div>
              )}
              </div>

              {/* Contenedor del PDF Unificado */}
              {previewUnificadoUrl && (
                <div className="soat-modal-preview-col" style={{ flex: 1, borderLeft: '1px solid #e2e8f0', paddingLeft: '20px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <h4 style={{ margin: 0, color: '#1e293b' }}>📄 PDF Unificado</h4>
                    <button 
                      onClick={closePreviewUnificado}
                      style={{ background: '#ef4444', color: '#fff', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      Cerrar Vista
                    </button>
                  </div>
                  <iframe
                    title="PDF Unificado"
                    src={previewUnificadoUrl}
                    width="100%"
                    style={{ border: '1px solid #cbd5e1', borderRadius: '8px', flex: 1, height: '100%' }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* MODAL SALDO RECARGAS SOAT */}
      <SoatRechargeModal
        isOpen={showSaldoSoatsModal}
        onClose={() => setShowSaldoSoatsModal(false)}
        onSuccess={fetchBalance}
      />

      {/* MODAL DETALLE DE SOAT */}
      <DetalleSoatModal
        isOpen={isDetailModalOpen}
        tramiteId={selectedTramiteId}
        onClose={() => {
          setIsDetailModalOpen(false);
          setSelectedTramiteId(null);
        }}
      />

      <HistorialSoatModal 
        isOpen={showHistorialModal}
        onClose={() => setShowHistorialModal(false)}
      />
    </div>
  );
};

export default SoatSubmodulo;
